// extracted by mini-css-extract-plugin
export var activeDot = "_a0-c";
export var buttonContainer = "_a0-9";
export var channelButton = "_a0-a";
export var clickable = "_a0-d";
export var content = "_a0-0";
export var contentFull = "_a0-2";
export var contentThird = "_a0-1";
export var contentWrapper = "_a0-7";
export var description = "_a0-5";
export var heightShort = "_a0-f";
export var image = "_a0-3";
export var imageContainer = "_a0-4";
export var selectButton = "_a0-e";
export var spinnerContainer = "_a0-b";
export var titleContent = "_a0-8";
export var titleWrapper = "_a0-6";